import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Catalog } from '@entity/catalog';
import { MainDataService } from '@service/main-data.service';

export const CatalogsResolve: ResolveFn<Catalog[]> = () => {
  return inject(MainDataService).getCatalogs();
};
